<template>
  <div class="events">
    <modal :title="'Новое мероприятие'" v-if="modal" @close="switchModal">
      <create-event @close="switchModal"/>
    </modal>
    <ccs-header :title="'Мероприятия'"/>
    <div class="events-content">
      <div class="events-actions">
        <nav-bar :dataFunction="getEvents" :orderFields="orderFields"/>
        <div class="actions-add" v-if="permissionsStatus.isEventCreateAllowed">
          <button class="ccs-button ccs-button--white" @click="switchModal">
            <img src="@/assets/icons/add.svg" alt="" class="button-icon">
            Добавить мероприятие
          </button>
        </div>
      </div>
      <ccs-table :data="events" :columnsDefs="columnsDefs"
        :defaultActions="defaultActions" @delete="removeEvent"
        @row_click="(row) => $router.push({ name: 'event', params: { eventID: row.id } })">
      </ccs-table>
      <pagination :dataFunction="getEvents"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import { PermissionsList } from '@/helpers/permissions';

import Header from '@/layouts/Header.vue';
import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';
import NavBar from '@/components/NavBar.vue';
import Pagination from '@/components/Pagination.vue';

import CreateEvent from '@/components/modals/events/CreateEvent.vue';

export default {
  name: 'Events',
  components: {
    'ccs-header': Header,
    'ccs-table': Table,
    Modal,
    CreateEvent,
    NavBar,
    Pagination,
  },
  data() {
    return {
      PermissionsList,
      modal: false,
      orderFields: [{
        prop: 'id',
        text: 'ID',
      }, {
        prop: 'full_name',
        text: 'Названию',
      }, {
        prop: 'event_type_id',
        text: 'Типу',
      }, {
        prop: 'status',
        text: 'Статусу',
      }],
      columnsDefs: [{
        name: `status`,
        title: `Соĸращенное наименование мероприятия`,
        prop: `short_name`,
      }, {
        name: `type`,
        title: `Тип мероприятия`,
        prop: `type`,
      }],
    };
  },
  computed: {
    ...mapState('events', ['events', 'eventTypes']),
    ...mapGetters('session', ['permissionsStatus']),
    defaultActions() {
      return {
        isTitleHidden: true,
        delete: this.permissionsStatus.isEventDeleteAllowed,
        rowClick: true,
      };
    },
  },
  methods: {
    ...mapActions('events', ['getEvents', 'deleteEvent']),
    switchModal() {
      this.modal = !this.modal;
    },
    async removeEvent(event) {
      try {
        await this.deleteEvent(event.id);
        this.$toasted.success('Мероприятие удалено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.events {

  &-content {
    margin: 0 33px;
  }

  &-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .actions {

    &-add {
      margin-left: 15px;
    }

  }

  .ccs-table {
    margin-top: 28px;
  }

}
</style>
